import { TSetting, TTutorialTrigger } from 'types';
import { create } from 'zustand';

type State = {
  openTutorial: boolean;
  tutorialTrigger: TTutorialTrigger | null;
  settingNoti: TSetting;
  settingEmail: TSetting;
};

type Actions = {
  setOpenTutorial: (value: boolean, trigger?: TTutorialTrigger) => void;
  setSettingNoti: (value: TSetting) => void;
  setSettingEmail: (value: TSetting) => void;
};

const useSettingStore = create<State & Actions>((set) => ({
  openTutorial: false,
  tutorialTrigger: null,
  settingNoti: {},
  settingEmail: {},
  setOpenTutorial: (value: boolean, trigger?: TTutorialTrigger) =>
    set(() => ({
      openTutorial: value,
      tutorialTrigger: value ? trigger ?? null : null,
    })),
  setSettingNoti: (value: TSetting) => set(() => ({ settingNoti: value })),
  setSettingEmail: (value: TSetting) => set(() => ({ settingEmail: value })),
}));

export default useSettingStore;
